import { axiosBaseRequest } from 'api/helpers';
import { personalInfoUrl } from 'api/endpoints';

export const personalInfoRequest = (data) => axiosBaseRequest({
  method: 'POST',
  url: personalInfoUrl,
  data,
});
